import React, { useState } from 'react';
import { ScrollView, View } from 'react-native';
import { Auth as Authorization } from 'aws-amplify';
import { Box, Button, FormControl, Icon, IconButton, Input, VStack } from 'native-base';
import { containerStyle } from 'src/styles/containerStyle';
import { inputStyle } from 'src/styles/inputStyle';
import ProgressBar from 'src/components/ProgressBar';
import InweonLogo from 'src/components/InweonLogo';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { formProps } from 'src/styles/formProps';
import { getText } from 'src/utils/i18n';

interface ForgotPasswordFormState {
    confirmationCode: string,
    password: string
}

export default function ConfirmForgotPasswordPage({ route, navigation }) {

    const [securePasswordEntry, setSecurePasswordEntry] = React.useState(true);
    const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

    const [formData, setData] = React.useState<ForgotPasswordFormState>({
        confirmationCode: '',
        password: ''
    });

    const [errors, setErrors] = React.useState({});

    const validate = () => {
        if (formData.confirmationCode === undefined
            || formData.confirmationCode.length === 0) {
            setErrors({
                confirmationCode: 'Confirmation code is required'
            });
            return false;
        } else if (formData.password === undefined
            || formData.password.length === 0) {
            setErrors({
                password: 'Password is required'
            });
            return false;
        } else if (formData.password.length < 8) {
            setErrors({
                password: 'Password must be at least 8 characters'
            });
            return false;
        }
    };

    const handleLogin = async () => {
        setShowLoadingIndicator(true)
        Authorization.forgotPasswordSubmit(route.params.username, formData.confirmationCode, formData.password).then(async () => {
            setShowLoadingIndicator(true)
            navigation.navigate('Login')
        }).catch((e) => {
            console.log('error occurred', e)
            setErrors({
                ...errors,
                formError: e.message
            });
            setShowLoadingIndicator(false)
        });
    }

    const onSubmit = () => {
        const isValid = validate();
        if (isValid) {
            // submit the data
            handleLogin()
        }
    };

    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <ProgressBar isVisible={showLoadingIndicator} progressText="Setting new password..." />
            <ScrollView automaticallyAdjustKeyboardInsets={true}>
                <InweonLogo title={getText('setNewPasswordTitle')} />

                <VStack width={formProps.width}
                    style={containerStyle.formContainer} mx="3">
                    <FormControl isRequired>
                        <FormControl.Label>Confirmation Code</FormControl.Label>
                        <Input
                            style={inputStyle.nativeInput}
                            isInvalid={'confirmationCode' in errors}
                            placeholder="********"
                            onChangeText={value => setData({
                                ...formData,
                                confirmationCode: value
                            })} />
                        {'confirmationCode' in errors ? <FormControl.ErrorMessage>{errors['confirmationCode']}</FormControl.ErrorMessage> : null}

                        <FormControl.Label>Password</FormControl.Label>
                        <Input
                            secureTextEntry={securePasswordEntry}
                            style={inputStyle.nativeInput}
                            isInvalid={'password' in errors}
                            InputRightElement={
                                <IconButton
                                    onPress={() => {
                                        setSecurePasswordEntry(!securePasswordEntry)
                                    }}
                                    icon={<MaterialCommunityIcons name="eye" />} />
                            }
                            placeholder="********"
                            onSubmitEditing={onSubmit}
                            onChangeText={value => setData({
                                ...formData,
                                password: value
                            })} />
                        {'password' in errors ? <FormControl.ErrorMessage>{errors['password']}</FormControl.ErrorMessage> : null}
                    </FormControl>
                    <Button onPress={onSubmit} mt="5">
                        Set new password
                    </Button>
                    {'formError' in errors ? <Text color="red.500" mt="2">{errors['formError'] || ""}</Text> : null}
                </VStack>
            </ScrollView>

        </Box>
    );
}